<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer000">
<p class="author-blurb ParaOverride-1" lang="en-US">Tony departed his native New Zealand in 1964, working his way to the UK for a holiday. The ‘holiday’ lasted 26 years, during which time he served in the Royal Air Force as a pilot and later joined a civil airline.</p>
<p class="author-blurb" lang="en-US">He and his wife, Maureen, have been living in Western Australia since 1993. He retired from flying in 2001 and has since spent his leisure time tending his small vineyard and repairing watches and clocks.</p>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer001">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer002">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer003">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer004">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt1.jpg"/>
</div>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer005">
<p class="copyright-heading" lang="en-US">Copyright © Tony Anderson 2024</p>
<p class="copyright-normal ParaOverride-1" lang="en-US">The right of <span class="CharOverride-1" lang="">Tony Anderson</span> to be identified as author of this work has been asserted by the author in accordance with sections 77 and 78 of the Copyright, Designs and Patents Act 1988.</p>
<p class="copyright-normal ParaOverride-1" lang="en-US">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the publishers.</p>
<p class="copyright-normal ParaOverride-1" lang="en-US">Any person who commits any unauthorised act in relation to this publication may be liable to criminal prosecution and civil claims for damages.</p>
<p class="copyright-normal ParaOverride-1" lang="en-US">A CIP catalogue record for this title is available from the British Library.</p>
<p class="copyright-normal" lang="en-US">ISBN 9781035803927 (Paperback)</p>
<p class="copyright-normal" lang="en-US">ISBN 9781035803934 (Hardback)</p>
<p class="copyright-normal ParaOverride-1" lang="en-US">ISBN 9781035803941 (ePub e-book)</p>
<p class="copyright-normal ParaOverride-1" lang="en-US">www.austinmacauley.co.uk</p>
<p class="copyright-normal" lang="en-US">First Published 2024</p>
<p class="copyright-normal" lang="en-US">Austin Macauley Publishers Ltd®</p>
<p class="copyright-normal" lang="en-US">1 Canada Square </p>
<p class="copyright-normal" lang="en-US">Canary Wharf</p>
<p class="copyright-normal" lang="en-US">London</p>
<p class="copyright-normal _idGenParaOverride-1" lang="en-US">E14 5AA</p>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer006">
</div>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer008">
<p class="images" lang="en-US"><img alt="" class="_idGenObjectAttribute-2" src="image/first.jpg"/></p>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer009">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer010">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt2.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer011">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer012">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt3.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer013">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer014">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt4.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer015">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer016">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt5.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer017">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer018">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt6.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer019">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer020">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt7.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer021">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer022">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt8.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer023">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer024">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt9.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer025">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer026">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt10.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer027">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer028">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt11.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer029">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer030">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt12.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer031">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer032">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt13.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer033">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer034">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt14.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer035">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer036">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt15.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer037">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer038">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt16.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer039">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer040">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt17.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer041">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer042">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt18.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer043">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer044">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt19.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer045">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer046">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt20.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer047">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer048">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt21.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer049">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer050">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt22.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer051">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer052">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt23.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer053">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer054">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt24.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer055">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer056">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt25.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer057">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer058">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt26.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer059">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer060">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt27.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer061">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer062">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt28.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer063">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer064">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt29.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer065">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer066">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt30.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer067">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer068">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt31.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer069">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer070">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt32.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer071">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer072">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt33.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer073">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer074">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt34.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer075">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer076">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt35.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer077">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer078">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt36.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer079">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer080">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt37.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer081">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer082">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt38.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer083">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer084">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt39.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer085">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer086">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt40.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer087">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer088">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt41.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer089">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer090">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt42.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer091">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer092">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt43.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer093">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer094">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt44.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer095">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer096">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt45.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer097">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer098">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt46.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer099">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer100">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt47.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer101">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer102">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt48.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer103">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer104">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt49.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer105">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer106">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt50.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer107">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer108">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt51.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer109">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer110">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt52.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer111">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer112">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt53.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer113">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer114">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt54.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer115">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer116">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt55.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer117">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer118">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt56.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer119">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer120">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt57.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer121">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer122">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt58.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer123">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer124">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt59.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer125">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer126">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt60.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer127">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer128">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt61.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer129">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer130">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt62.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer131">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer132">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt63.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer133">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer134">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt64.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer135">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer136">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt65.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer137">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer138">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt66.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer139">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer140">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt67.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer141">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer142">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt68.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer143">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer144">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt69.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer145">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer146">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt70.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer147">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer148">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt71.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer149">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer150">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt72.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer151">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer152">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt73.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer153">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer154">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt74.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer155">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer156">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt75.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer157">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer158">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt76.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer159">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer160">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt77.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer161">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer162">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt78.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer163">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer164">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt79.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer165">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer166">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt80.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer167">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer168">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt81.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer169">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer170">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt82.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer171">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer172">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt83.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer173">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer174">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt84.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer175">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer176">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt85.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer177">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer178">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt86.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer179">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer180">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt87.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer181">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer182">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt88.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer183">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer184">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt89.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer185">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer186">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt90.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer187">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer188">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt91.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer189">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer190">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt92.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer191">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer192">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt93.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer193">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer194">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt94.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer195">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer196">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt95.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer197">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer198">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt96.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer199">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer200">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt97.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer201">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer202">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt98.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer203">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer204">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt99.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer205">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer206">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt100.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer207">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer208">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt101.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer209">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer210">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt102.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer211">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer212">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt103.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer213">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer214">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt104.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer215">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer216">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt105.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer217">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer218">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt106.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer219">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer220">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt107.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer221">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer222">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt108.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer223">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer224">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt109.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer225">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer226">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt110.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer227">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer228">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt111.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer229">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer230">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt112.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer231">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer232">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt113.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer233">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer234">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt114.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer235">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer236">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt115.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer237">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer238">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt116.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer239">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer240">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt117.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer241">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer242">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt118.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer243">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer244">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt119.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer245">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer246">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt120.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer247">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer248">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt121.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer249">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer250">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt122.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer251">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer252">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt123.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer253">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer254">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt124.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer255">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer256">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt125.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer257">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer258">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt126.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer259">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer260">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt127.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer261">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer262">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt128.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer263">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer264">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt129.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer265">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer266">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt130.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer267">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer268">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt131.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer269">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer270">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt132.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer271">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer272">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt133.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer273">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer274">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt134.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer275">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer276">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt135.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer277">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer278">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt136.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer279">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer280">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt137.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer281">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer282">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt138.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer283">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer284">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt139.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer285">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer286">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt140.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer287">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer288">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt141.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer289">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer290">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt142.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer291">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer292">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt143.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer293">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer294">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt144.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer295">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer296">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt145.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer297">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer298">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt146.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer299">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer300">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt147.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer301">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer302">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt148.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer303">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer304">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt149.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer305">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer306">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt150.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer307">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer308">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt151.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer309">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer310">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt152.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer311">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer312">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt153.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer313">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer314">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt154.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer315">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer316">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt155.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer317">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer318">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt156.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer319">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer320">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt157.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer321">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer322">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt158.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer323">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer324">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt159.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer325">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer326">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt160.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer327">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer328">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt161.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer329">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer330">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt162.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer331">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer332">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt163.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer333">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer334">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt164.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer335">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer336">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt165.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer337">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer338">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt166.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer339">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer340">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt167.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer341">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer342">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt168.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer343">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer344">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803927_txt169.jpg"/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781035803927_EPUB.vue?5f74874a